import { render } from "./Autocomplete.vue?vue&type=template&id=0b84a11e"
import script from "./Autocomplete.vue?vue&type=script&lang=js"
export * from "./Autocomplete.vue?vue&type=script&lang=js"

import "./Autocomplete.vue?vue&type=style&index=0&id=0b84a11e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__